import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, useTheme } from '@mui/material';

const PortfolioDetailTable = ({ list, columns }: { list: any; columns: GridColDef[] }) => {
  // theme
  const theme = useTheme();

  return (
    <Box
      sx={{
        maxHeight: '100%',
        width: '100%',
        '& .MuiDataGrid-root': {
          borderRadius: '10px',
          overflow: 'hidden', // To ensure the border-radius is applied correctly
        },
        '& .MuiDataGrid-main': {
          borderRadius: '10px', // Outer border radius
        },
        '& .MuiDataGrid-columnHeaders': {
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        },
        '& .MuiDataGrid-virtualScroller': {
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
        },
        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          paddingRight: '5px',
        },
      }}
    >
      <DataGrid
        autoHeight
        sx={{
          border: 'none',
          boxShadow: '0px 0px 4px 0px #00000026',
          '& .MuiDataGrid-columnHeader': {
            height: '46px !important',
            background: theme.brand.primary,
            color: '#ffffff',
            typography: 'subtitle2',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:selected': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },

          '& .MuiDataGrid-cell': {
            outline: 'none',
            typography: 'body2',
            color: theme.greyscale.grey3,
            display: 'flex',
            alignItems: 'center',
          },
        }}
        hideFooter
        rows={list}
        columns={columns}
        getRowId={(list) => String(list.index)}
      />
    </Box>
  );
};

export default PortfolioDetailTable;
